import { AdasBox, AdasTypography } from '@components/wrapper-components'

const ALLSTATE_CALIBRATION_LEVELS = [
  'Level 3a Static: Targeted Calibrations (All Other Makes)*',
  'Level 3b Static: Targeted Calibrations (Mercedes, Subaru)**',
  'Level 3c Static: Targeted Calibrations (Porsche, Audi, VW)***'
]

export const ProductContractBanner = ({ referralData }) => {
  const isAllstate = referralData?.company?.toLowerCase() === 'allstate'
  const shouldShowLevels = isAllstate

  return (
    <AdasBox
      sx={{
        border: shouldShowLevels ? '1px solid #09519A' : 'none',
        borderRadius: shouldShowLevels ? '4px' : '6px',
        overflow: 'hidden',
        mt: 1,
        mb: 2
      }}
    >
      {/* Header */}
      <AdasBox
        sx={{
          backgroundColor: '#09519A', // Allstate blue from Figma
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '10px 16px',
          borderRadius: shouldShowLevels ? '0' : '6px',
          width: '100%'
        }}
      >
        <AdasTypography variant='body1' fontWeight='500' sx={{ letterSpacing: '0.03em', textTransform: 'capitalize' }}>
          {referralData?.company} – National Contract pricing in use
        </AdasTypography>
      </AdasBox>

      {/* Allstate-specific calibration levels */}
      {shouldShowLevels && (
        <AdasBox
          sx={{
            backgroundColor: '#fff',
            padding: '16px',
            display: 'flex',
            flexDirection: 'column',
            gap: 1
          }}
        >
          {ALLSTATE_CALIBRATION_LEVELS.map((level, index) => (
            <AdasTypography key={index} variant='body2' sx={{ fontSize: '14px', color: '#374151', fontWeight: '500' }}>
              {level}
            </AdasTypography>
          ))}
        </AdasBox>
      )}
    </AdasBox>
  )
}
